<div class="flex flex-col h-full min-h-0">
    <div class="flex-1 min-h-0 overflow-y-auto bg-on-primary rounded-t-xl mx-1 pb-2">
        @if (!createFieldInterventionService.activeLayers().length) {
            <div class="text-center flex flex-col items-center justify-center gap-4">
                @if (createFieldInterventionService.isLoading()) {
                    <app-loading class="mt-8vh" />
                } @else {
                    <app-create-field-intervention-information
                        [icon]="['fas', 'layer-group']"
                        [subTitle]="'selectLayerInformation'"
                        [title]="'selectLayer'" />

                    <app-layer-select
                        class="h-full"
                        [hasTabularLayers]="false" />
                }
            </div>
        } @else {
            <app-entity-selection-field-intervention-table />
        }
    </div>

    <div class="bottom-0 sticky bg-white w-full rounded-sm footer-shadow">
        <app-create-field-intervention-footer />
    </div>
</div>
